<template>
  <div class="wrapper">
      <img
        v-if="isLargeScreen === true"
        src="https://p4-ky.wsukwai.com/udata/pkg/KMOVIE-CDN/image/bottomBG.png" class="bottom-mask" />
      <div class="box">
      <div class="header">
        <img
          src="https://p4-ky.wsukwai.com/udata/pkg/kmovie/common-figma-plugin/aeb5d0d0-23d9-4fba-8a93-2f32d468f647.png" />
        <div class="rule" @click="emit('toRule')">活动细则</div>
        <div>
          联系我们 <a href="mailto:kling@kuaishou.com">kling@kuaishou.com</a>
        </div>
      </div>
      <div class="footer">
        主办方：可灵AI X 快影<br />
        协办方：中国美术学院 ｜ 北京电影学院摄影学院 ｜ 北京师范大学艺术与传媒学院 ｜
        中国传媒大学动画与数字艺术学院 ｜ 中央美术学院团委<br />
        联合评审单位：清华大学新闻与传播学院<br />
      </div>
      </div>
  </div>
</template>
<script setup lang="ts">
const emit = defineEmits(["toRule"]);

const isLargeScreen = ref(false);
const resize = () => {
  isLargeScreen.value = window.innerWidth >= 1360;
};
onMounted(() => {
  resize();
});
window.addEventListener("resize", resize);
window.addEventListener("orientationchange", resize);

onBeforeUnmount(() => {
  window.removeEventListener("resize", resize);
  window.removeEventListener("orientationchange", resize);
})

</script>
<style scoped lang="less">
.wrapper {
  width: 100%;
  min-height: 5.12rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  @media screen and (max-width: 1360px) {
        flex-direction: row;
      }
  .bottom-mask {
      position: sticky;
      width: 100%;
      height: 6rem;
      bottom: 0;
    }
  .box {
    width: 22.36rem;
    font-size: 0.32rem;
    font-weight: 400;
    line-height: 0.44rem;
    color: rgba(255, 255, 255, 0.7);

    @media screen and (max-width:1360px) and (min-width:700px) {
      max-width: 80vw;
    }

    @media screen and (max-width: 1360px) {
      font-size: 0.24rem;
      line-height: 0.32rem;
      font-weight: 400;
    }
    .header {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      padding: 0.48rem;
      position: relative;

      @media screen and (max-width: 1360px) {
        padding: 0.48rem 0;
        margin: 0 0.48rem;
        flex-direction: column;
        align-items: flex-start;
      }

      &::after {
        position: absolute;
        content: "";
        width: 100%;
        left: 0;
        bottom: 0;
        height: 1px;
        opacity: 0.2;
        background-size: contain;
        background-image: linear-gradient(90deg,
            #ffffff 0%,
            #ffffff 20%,
            #b6ffe0 60%,
            #81d2ff 70%,
            #b7a5ff 80%,
            #b7a5ff 100%);
      }

      .rule {
        cursor: pointer;
        margin: 0 0.8rem;

        @media screen and (max-width: 1360px) {
          margin: 0.4rem 0;
        }
      }

      img {
        width: 3.12rem;
      }

      a {
        color: rgba(255, 255, 255, 0.7);
      }
    }

    .footer {
      margin-top: 0.56rem;
      font-size: 0.26rem;
      font-weight: 300;
      line-height: 0.4rem;
      color: rgba(255, 255, 255, 0.5);

      @media screen and (max-width: 1360px) {
        padding: 0.48rem;
        font-size: .24rem;
      }
    }
  }
}
</style>
